var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9165 4C1.9165 2.48122 3.14772 1.25 4.6665 1.25H9.75206C10.4814 1.25 11.1809 1.53973 11.6966 2.05546L13.2777 3.63657C13.7934 4.15229 14.0832 4.85177 14.0832 5.58111V12C14.0832 13.5188 12.852 14.75 11.3332 14.75H4.6665C3.14772 14.75 1.9165 13.5188 1.9165 12V4ZM4.6665 2.75C3.97615 2.75 3.4165 3.30964 3.4165 4V12C3.4165 12.6904 3.97615 13.25 4.6665 13.25H11.3332C12.0235 13.25 12.5832 12.6904 12.5832 12V5.58111C12.5832 5.24959 12.4515 4.93165 12.2171 4.69723L10.6359 3.11612C10.4015 2.8817 10.0836 2.75 9.75206 2.75H4.6665Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6665 1.5C9.94265 1.5 10.1665 1.72386 10.1665 2V4.33333C10.1665 4.79357 10.5396 5.16667 10.9998 5.16667H13.3332C13.6093 5.16667 13.8332 5.39052 13.8332 5.66667C13.8332 5.94281 13.6093 6.16667 13.3332 6.16667H10.9998C9.98732 6.16667 9.1665 5.34586 9.1665 4.33333V2C9.1665 1.72386 9.39036 1.5 9.6665 1.5Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoice);
export default __webpack_public_path__ + "static/media/icon-invoice.b5705b3c70a695333031f12c8c336ff8.svg";
export { ForwardRef as ReactComponent };